import React from 'react';
import DamageReportEntity from '../../../entity/DamageReportEntity';
import './wagonLabelsStyles.scss';

type Props = {
  registration: string;
  source: 'left-panel' | 'details';
  labels: string[];
};

const WagonRegistrationLabels = ({ registration, source, labels }: Props) => {
  const wagonExistingLabels = labels.map((label) => DamageReportEntity.LABELS.find((value) => value.value === label));

  return (
    <div className={`${source}-vehicle-labels`}>
      {wagonExistingLabels.map((l) => (
        <div className={`wagon-label-${l?.value}`} key={`wagon-${registration}-${l?.value}`}>
          {l?.label}
        </div>
      ))}
    </div>
  );
};

export default WagonRegistrationLabels;
